import React, {PureComponent} from 'react';

import classes from './window-element.module.scss';

const MainPicture = (props) => {
	const {srcwebp, srcimg, label, pathimages } = props;
	const img = pathimages + srcimg,
		  webpimg = pathimages + srcwebp;

	if ( srcwebp === undefined || srcwebp === ''){
		return(
			<img src={img} alt={label} />
		)
	} else {
		return(
			<picture>
				<source srcSet={webpimg} type="image/webp" />
				<img src={img} alt={label} />
			</picture>
		)
	}
}


export default class WindowElement extends PureComponent{

	render(){
		const {label, thumbFile, thumbWebpFile, id, onRadioChanged, mainstate, onUpdateTypeWindow, pathimages} = this.props;

		const
			  el_id = `t${id}`,
			  flag = (id===mainstate.currentTypeWindowId) ? true: false;

		return (
			<div className={classes['wincalc-type-selector']}>
				<input type="radio" name="type" value={id} id={el_id}
					defaultChecked={flag}
					onChange={() => {
							onRadioChanged(id);
							onUpdateTypeWindow(id)
						}
					}
				/>
				<label htmlFor={el_id}>
					<MainPicture
						srcwebp = {thumbWebpFile}
						srcimg = {thumbFile}
						label = {label}
						pathimages = {pathimages}
					/>
					<span className={classes['label-title']}>{label}</span>
				</label>
			</div>
		)
	}
}